import React, { Component } from 'react';
import PaywallModal from "../../../components/PaywallModal";
import trackEvent from "../eventTracking";


class MyStudentsPageFeaturewall extends Component {
  constructor(props) {
    super(props);

    this.state = {
      yourX: props.yourX,
      players: props.players,
      selectedChildren: {},
      featurewallModalOpen: true,
      unlockText: props.unlockText,
      isSchoolAdmin: props.isSchoolAdmin
    }
  }

  ////////////////////////////////////////////
  // Helper Functions
  ////////////////////////////////////////////

  openFeaturewallModal = () => {
    this.setState({
      featurewallModalOpen: true
    });
  }

  onCloseFeaturewall = () => {
    this.setState({
      featurewallModalOpen: false
    });
  }

  onAcceptFeaturewall = () => {
    this.setState({
      featurewallModalOpen: false
    });
  }

  ////////////////////////////////////////////
  // Show an image. Any click opens up the featurewall modal
  ////////////////////////////////////////////

  render() {
    const yourX = this.state.yourX.plural;
    const imgPath = (yourX === 'children') ? '/files/static/my-students/your_children_screenshot.png' : '/files/static/my-students/your_students_screenshot.png';

    return (
      <div style={{textAlign: "center"}} className="my-students">
          <img src={imgPath} onClick={this.openFeaturewallModal}/>
            <PaywallModal
                open={this.state.featurewallModalOpen}
                onClose={this.onCloseFeaturewall}
                onAccept={this.onAcceptFeaturewall}
                onReject={this.onCloseFeaturewall}
                isSchoolAdmin={this.state.isSchoolAdmin}>
              <h3 className="PaywallModal__title">Unlock Learner Profiles</h3>
              <div className="PaywallModal__paywall-content">Become a Premium member to set up profiles for your {this.state.yourX.plural}, {this.props.unlockText}</div>
            </PaywallModal>
      </div>
    );
  }
}
export default MyStudentsPageFeaturewall;
